<div style="display: block; margin: 0 auto">
  <h1>
    Invalid or no required parameters provided, provide <b>tenantId</b> and/or <b>redirect</b> parameters.
  </h1>
</div>